export default __webpack_public_path__ + "static/media/c01.9c5c0169.jpg";